<div class="form-switch">
    <div class="labels" *ngIf="label || title">
        <label class="form-check-label" *ngIf="title">{{ title | translate }}</label>
        <label class="form-check-label disclaimer" *ngIf="label">{{ label | translate }}</label>
    </div>
    <div class="horizontal">
        <ng-content></ng-content>
        <input (change)="switch()" [checked]="value" [formControl]="control" class="form-check-input" type="checkbox" />
    </div>
</div>
